/**
 * DeviceSlot entity class
 */

import moment from 'moment'

/**
 * DeviceSlotFactory
 * returns DeviceSlot entity class
 *
 * @class DeviceSlotFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.DeviceSlot} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DeviceSlotFactory
 */
/* @ngInject */
export default function DeviceSlotFactory ($http, alertLiteSvc, Entity) {
  /* === DeviceSlot class === */

  /**
   * DeviceSlot model
   *
   * @class DeviceSlot
   * @classdesc DeviceSlot model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing DeviceSlot entity fields
   * @return {models.DeviceSlot} DeviceSlot entity
   */
  function DeviceSlot () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  DeviceSlot.prototype = Object.create(Entity.prototype)
  DeviceSlot.prototype.constructor = DeviceSlot

  /* === DeviceSlot instance methods & fields === */

  Object.assign(DeviceSlot.prototype, {

    /**
     * instance fields
     *
     * @memberof models.DeviceSlot#
     * @type {Object}
     */
    _fields: {
      id: Number,
      status: false,
      code: String,
      codeExpirationTime: moment,
      subscriber: 'Subscriber'
    },

    /**
     * url template
     *
     * @memberof models.DeviceSlot#
     * @type {String}
     */
    _urlTemplate: 'api/subscribers/{{subscriber.id}}/slots/{{::id}}',

    /**
     * Link slot, performing PATCH request to the server
     *
     * @memberof models.DeviceSlot#
     * @return {Promise} promise
     */
    _link: function () {
      return $http.patch(this._url, '"LINK"')
        .data()
        .then(
          response => {
            this._copy(response)
            return response
          }
        ).catch(alertLiteSvc.alertError)
    },

    /**
     * Unlink slot, performing PATCH request to the server
     *
     * @memberof models.DeviceSlot#
     * @return {Promise} promise
     */
    _unlink: function () {
      return $http.patch(this._url, '"UNLINK"')
        .data()
        .then(
          response => {
            this.code = this.codeExpirationTime = null
            return response
          }
        ).catch(alertLiteSvc.alertError)
    }

  })

  /* === DeviceSlot static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(DeviceSlot, Entity)
  DeviceSlot._name = 'DeviceSlot'
  DeviceSlot.init()

  // permissions
  DeviceSlot.access = {
    create: 'createDeviceSlot',
    edit: 'editDeviceSlot',
    delete: 'deleteDeviceSlot'
  }

  return DeviceSlot
}
